export default "/Frontend/dist/ppt.f80e57a8daba948bab81ec3d38f14e65.svg";